module.exports = __webpack_public_path__ + "img/beast4.6f2daa83.png";